module.exports = "  <footer class=\"footer\">\n  \t<div class=\"container-fluid\">\n  \t\t<div class=\"row\">\n  \t\t\t<div class=\"col-sm-2\"></div>\n  \t\t\t<div class=\"col-md-4 tc\">\n  \t\t\t<!-- <span>Copyright 2018 @ CTOS Business systems Sdn Bhd.</span> -->\n  \t\t\t</div>\n  \t\t\t<div class=\"col-md-6 tr\">\n  \t\t\t<!-- <a>Privacy Policy</a> &nbsp;  -->\n  \t\t\t<!-- <a>Cookie policy</a> &nbsp;  -->\n  \t\t\t<!-- <a>Terms of Use</a>-->\n  \t\t\t</div>\n  \t\t</div>\n  \t</div></footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = 495
// module chunks = 1